import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { AgGridReact } from 'ag-grid-react';
import { Card } from 'antd';

const height = window.innerHeight * .60;

const defaultColDef = {
    sortable: true,
    resizable: true,
    filter: true,
};

const columnDefs = [
    { headerName: 'Test or Profile Name', field: 'TestOrProfileName', filter: 'agTextColumnFilter', width: 200 },
    { headerName: 'Bill', field: 'BillAmount', type: 'numberColumn', filter: 'agNumberColumnFilter', width: 100, headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
    { headerName: 'IC', field: 'IC', type: 'numberColumn', filter: 'agNumberColumnFilter', width: 100, headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
    { headerName: 'IC Type', field: 'CommissionType' },
    { headerName: 'Percentage', field: 'CommissionPercentage', type: 'numberColumn', filter: 'agNumberColumnFilter', width: 100, headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
    { headerName: 'Flat', field: 'CommissionAmount', type: 'numberColumn', filter: 'agNumberColumnFilter', width: 100, headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
    { headerName: 'Bucket Type', field: 'CommissionCollectType' },
];

class RegistrationDetail extends Component {

    gridRef = React.createRef();

    constructor(props) {
        super(props);
        this.store = props.store;
    }

    fetchSummary = () => {
        this.store.fetchSummary();
    }

    refreshGrid = () => {
        this.gridRef.current.api.redrawRows();
    }

    render() {
        const registration = this.store.registration;
        const title = `Tests for Reg ${this.store.sidCode}`;
        return (

            <Card title={title} style={{height:'100%'}}>
                <div className="ag-theme-alpine" style={{ height: height, width: '100%' }}>
                    <AgGridReact
                        ref={this.gridRef}
                        defaultColDef={defaultColDef}
                        rowData={registration}
                        columnDefs={columnDefs}
                        rowHeight={25}
                    >
                    </AgGridReact>
                </div>
            </Card>

        )
    }
}

export default observer(RegistrationDetail)
